import styled from 'styled-components'
import withStyles from '@mui/styles/withStyles';
import {Colors, FontSizeInPixel} from './Constants'
import {StyledLink} from './residentPage/Links'

export const AttachmentFileName = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
`

export const AttachmentFile = styled.div`
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  min-height: 64px;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`

export const AttachmentFileLink = withStyles({
    root: {
        color: Colors.Body,
        fontSize: FontSizeInPixel.Body,
        lineHeight: 1.5,
        display: 'block',
        marginTop: '10px',
        width: '100%',
        '&:hover': {
            textDecoration: 'none',
        }
    },
})(StyledLink)
